import styled from 'styled-components';

interface WrapperProps {
  $visible: boolean;
}

export const Wrapper = styled.div<WrapperProps>(({ $visible }) => ({
  height: '100%',
  width: '100%',
  display: $visible ? 'flex' : 'none',
  position: 'relative',
  justifyContent: 'center',
}));

export const Video = styled.video(({ theme: { borderRadius } }) => ({
  height: '100%',
  width: '100%',
  borderRadius: borderRadius.medium,
}));

export interface ProgressProps {
  $progressPercent: number;
}

export const Progress = styled.div<ProgressProps>(
  ({ theme: { size, color, borderRadius }, $progressPercent }) => ({
    background: color.background.primary.default(),
    height: size.units(0.375),
    width: `calc(100% - ${size.units(1)})`,
    position: 'absolute',
    bottom: 0,
    borderRadius: borderRadius.medium,
    '&:before': {
      content: '""',
      backgroundColor: color.background.accent.default(),
      width: `${$progressPercent}%`,
      height: size.units(0.375),
      zIndex: 3,
      position: 'absolute',
      borderRadius: borderRadius.medium,
    },
  }),
);
